import React from "react";
import "./secondary-wrapper.css";
function SecondaryWrapper({ title, children }) {
  function handleOutsideClick() {
    document.body.classList.remove("effect");
  }
  return (
    <div className="main-wrapper" onClick={handleOutsideClick}>
      <div className="page-header">
        <div className="container">
          <h1 className="text-white">{title}</h1>
        </div>
      </div>
      

      <div className="container">
        <div className="card overlap_30 p-2">{children}</div>
      </div>
    </div>
  );
}

export default SecondaryWrapper;
